export enum AppAction {
  FromBackgroundScript = '[AppAction] FromBackgroundScript',
  GetLocalStorageResponse = '[AppAction] GetLocalStorageResponse',
  GetProfileEmailResponse = '[AppAction] GetProfileEmailResponse',
  GetUserDetailsResponse = '[AppAction] GetUserDetailsResponse',
  LocalStorageChanged = '[AppAction] LocalStorageChanged',
  SetLocalStorageResponse = '[AppAction] SetLocalStorageResponse',
  ShowAntipatternPopup = '[AppAction] ShowAntipatternPopup',
  ShowAntipatternPopupV2 = '[AppAction] ShowAntipatternPopupV2',
  ShowNotificationPopup = '[AppAction] ShowNotificationPopup',
}
